import React from "react";
import { TextField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

const TaskNameField = React.memo(() => (
  <TextField
    name={fieldTypes.TASK_NAME}
    label={translate(null, "care_team_tasks.form.fields.task_name", "label")}
    placeholder={translate(null, "care_team_tasks.form.fields.task_name", "placeholder")}
  />
));

export default TaskNameField;
